import { createContext, useContext } from "react";

export const EmployeeAuthContext = createContext();

export const useEmployeeAuthContext = () => {

    const context = useContext(EmployeeAuthContext);

    if (!context) {

        throw new Error(
            "useEmployeeAuthContext must be used inside an EmployeeAuthContextProvider"
        );

    }

    return context;
};